import { TABLE_FIELDS } from './tableFields';

export const PATIENTS_TABLE_FIELDS: Array<TABLE_FIELDS> = [
  TABLE_FIELDS.NAME,
  TABLE_FIELDS.EMAIL,
  TABLE_FIELDS.DATE_OF_BIRTH,
  TABLE_FIELDS.STATUS,
];
